import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Stvarce",
  "description": "",
  "published": "2006-05-31T00:00:00.000Z",
  "redirect_from": ["/blog/stvarce/swizec/409"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Kdo bi si mislil, da je minilo ze pet dni od kar je bil ta koscek tega majhnega koscka vesolja posodobljen. Zanimivo je kaj se zgodi s casom pod poeinsteinovskimi pogoji ukrivljanja casa in distorcije percepcije, ki jo s skupnim imenom imenujemo kar ukrivi-moj-razpolozljivi-caso-okoli-lenobe, niti sam Einstein ni mogel tega razloziti.`}</p>
    <p>{`V glavnem, danes se bo v tem psotu pojavilo nekaj zanimiv linkov. Za zacetek recimo tale stvarca, ki odgovori na najbolj perece vprasanje clovesta. `}<a parentName="p" {...{
        "href": "http://www.style.org/unladenswallow/"
      }}>{`Kaksna tocno JE zracna hitrost neobremenjene lastovke`}</a>{`. Ze v casih `}<a parentName="p" {...{
        "href": "http://en.wikiquote.org/wiki/Holy_Grail"
      }}>{`Svetega Grala`}</a>{` so se s tem ukvarjali... kdor se ni videl tega `}<a parentName="p" {...{
        "href": "http://en.wikiquote.org/wiki/Holy_Grail"
      }}>{`Monty Python filma`}</a>{` naj se gre skrit pred oblicjem sveta dokler si ne ogleda takih zivljensko pomembnih stvari, saj nima v civiliziranem svetu sploh kaj poceti.`}</p>
    <p>{`Potem imamo tu se naprimer `}<a parentName="p" {...{
        "href": "http://www.blockfrenzy.com/"
      }}>{`tole`}</a>{` `}<a parentName="p" {...{
        "href": "http://www.blockfrenzy.com/"
      }}>{`stvar`}</a>{`, zelo zanimivo za nekaj tako preprostega kot je izogibanje nekaj norim skatlam z... skatlo.`}</p>
    <p>{`Danes sem odkril tudi `}<a parentName="p" {...{
        "href": "http://slashdot.org/"
      }}>{`nekaj`}</a>{` kar veliko ljudi oznacuje kot edino zivljenjsko pomembno `}<a parentName="p" {...{
        "href": "http://slashdot.org/"
      }}>{`stvar`}</a>{` in jo imenuje `}<a parentName="p" {...{
        "href": "http://slashdot.org/"
      }}>{`Slashdot`}</a>{`. Vse skupaj je predvsem zelo ogromno in me kar srat prime, ko vidim kaj vse lahko nastavim in kolik onastavitev niti ne vem kaj v bistvu naj bi pocele. Bo potrebno malo bolj pregledati vse skupaj, ampak je videti kot dober vir novic.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      